<template>
	<div>
		<Tabs>
			<TabPane label="层级结构" name="tree" icon="ios-git-merge">
				<Tree :data="data2" :render="renderContent"></Tree>
			</TabPane>
			<TabPane label="列表结构" name="list" icon="ios-list">
				<Row style="padding-bottom: 10px;margin-top: 10px;">
					<Button type="primary" @click="">搜索</Button>
				</Row>
				<Table ref="selectionTable" :max-height="height" :data="data1" :columns="columns1" stripe border>
					<!-- <template slot-scope="{ row, index }" slot="deparams">
						<div style="display: flex;justify-content: space-around;">
							<Button type="primary" @click="clickUpdate(row)" style="padding: 5px 5px 6px;">编辑</Button>
							<Button type="primary" @click="clickDelete(row)" style="padding: 5px 5px 6px;">删除</Button>
						</div>
					</template> -->
				</Table>
				<Page :current="currentPage" :total="totalRows" :page-size="pageSize" show-sizer show-total
					@on-change="changePage" @on-page-size-change="changePageSize" style="text-align:right"></Page>
			</TabPane>
		</Tabs>

		<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<Icon type="md-create" />
				<span>搜索</span>
			</p>
			<div style="text-align:center">
				<CheckboxGroup v-model="selectedCondition" class="check_grop">
					<div>
						<Checkbox label="meterId">
							<span>表号</span>
						</Checkbox>
						<Input v-model="meterId" placeholder="请输入表号" style="width: 200px" />
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
			</div>
		</Modal>

		<Modal title="Title" v-model="showDialog" class="common_update_dialog">
			<div slot="header">
				<span>{{showTitle}}</span>
			</div>
			<div v-if="showType=='show'||showType=='save'">
				<span>编号</span>
				<Input :readonly="showType=='show'" v-model="currentRow.num" />
			</div>
			<div v-if="showType=='show'||showType=='save'">
				<span>公司编号</span>
				<Input :readonly="showType=='show'" v-model="currentRow.companyNum" />
			</div>
			<div v-if="showType=='show'||showType=='save'">
				<span>上级编号</span>
				<Input readonly v-model="currentRow.parentNum" />
			</div>
			<div v-if="showType=='show'||showType=='save'">
				<span>上级名称</span>
				<Input readonly v-model="currentRow.parentName" />
			</div>
			<div>
				<span>身份证号</span>
				<Input :readonly="showType=='show'" v-model="currentRow.idCard" />
			</div>
			<div>
				<span>姓名</span>
				<Input :readonly="showType=='show'" v-model="currentRow.name" />
			</div>
			<div>
				<span>用户名</span>
				<Input :readonly="showType=='show'" v-model="currentRow.username" />
			</div>
			<div>
				<span>密码</span>
				<Input :readonly="showType=='show'" v-model="currentRow.password"
					:placeholder="showType=='save'?'':'留空则不修改'" />
			</div>
			<div>
				<span>电话</span>
				<Input :readonly="showType=='show'" v-model="currentRow.phone" />
			</div>
			<div>
				<span>性别</span>
				<Input :readonly="showType=='show'" type="number" v-model="currentRow.gender" />
			</div>
			<div>
				<span>职位</span>
				<Input :readonly="showType=='show'" v-model="currentRow.position" />
			</div>
			<div>
				<span>类型</span>
				<Input :readonly="showType=='show'" type="number" v-model="currentRow.type" />
			</div>
			<div>
				<span>备注</span>
				<Input :readonly="showType=='show'" v-model="currentRow.remark" />
			</div>
			<div v-if="showType=='show'">
				<span>创建时间</span>
				<Input readonly v-model="currentRow.createTime" />
			</div>
			<div slot="footer">
				<Button v-if="showType=='save'||showType=='update'" :loading="submitLoading" type="info" size="large"
					long @click="submitTreeUpdate">立即提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		name: "staff_manage",
		data() {
			let that = this;
			return {
				height: window.innerHeight,
				buttonProps: {
					type: "default",
					size: "small"
				},
				columns1: [{
						title: "编号",
						width: 100,
						key: "num",
						align: "center"
					},
					{
						title: "上级编号",
						width: 100,
						key: "parentNum",
						align: "center"
					},
					{
						title: "类型",
						width: 100,
						key: "type",
						align: "center"
					},
					{
						title: "公司编号",
						width: 100,
						key: "companyNum",
						align: "center"
					},
					{
						title: "身份证号",
						width: 200,
						key: "idCard",
						align: "center"
					},
					{
						title: "姓名",
						width: 100,
						key: "name",
						align: "center"
					},
					{
						title: "用户名",
						width: 100,
						key: "username",
						align: "center"
					},
					{
						title: "电话",
						width: 150,
						key: "phone",
						align: "center"
					},
					{
						title: "性别",
						width: 100,
						key: "gender",
						align: "center"
					},
					{
						title: "职位",
						width: 100,
						key: "position",
						align: "center"
					},
					{
						title: "备注",
						width: 100,
						key: "remark",
						align: "center"
					},
					{
						title: "创建时间",
						width: 200,
						key: "createTime",
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								global.dateFtt(
									"yyyy-MM-dd hh:mm:ss",
									new Date(params.row.createTime)
								)
							);
						}
					},
					// {
					// 	title: "操作",
					// 	fixed: 'right',
					// 	width: 150,
					// 	slot: "deparams",
					// 	align: "center"
					// }
				],
				meterId: '',
				currentRow: {},
				data1: [],
				data2: [],
				loading: true,
				submitLoading: false,
				modal8: false,
				currentPage: 1,
				totalRows: 0,
				pageSize: 30,
				selectedCondition: [],
				requestBody: {},
				showType: 'show',
				showTitle: '详情',
				isRoot: false,
				showDialog: false,
			};
		},
		created() {
			this.getDataList();
			this.getDataTree();
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			clickShow(row) {
				this.currentRow = row;
				this.showDetail = true;
			},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.currentPage = index;
				this.getDataList();
			},
			searchByCondition() {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.modal8 = false;
				this.currentPage = 1;
				this.getDataList();
			},
			renderRootContent(h, {
				root,
				node,
				data
			}) {
				return h("span", {
						style: {
							display: "inline-block",
							width: "100%"
						}
					},
					[
						h("span", [
							h("Icon", {
								props: {
									type: "ios-paper-outline"
								},
								style: {
									marginRight: "8px"
								}
							}),
							h("span", data.name)
						]),
						h("span", {
								style: {
									display: "inline-block",
									marginLeft: "32px",
									marginRight: "32px"
								}
							},
							[
								h("Button", {
									props: Object.assign({}, this.buttonProps, {
										icon: "ios-add",
										type: "primary"
									}),
									on: {
										click: () => {
											this.clickTreeSave(root, node, data);
										}
									}
								})
							]
						)
					]
				);
			},
			renderContent(h, {
				root,
				node,
				data
			}) {
				return h("span", {
						style: {
							display: "inline-block",
							width: "100%"
						}
					},
					[
						h("span", [
							h("Icon", {
								props: {
									type: "ios-paper-outline"
								},
								style: {
									marginRight: "8px"
								}
							}),
							h("span", data.name)
						]),
						h("span", {
								style: {
									display: "inline-block",
									marginLeft: "32px",
									marginRight: "32px"
								}
							},
							[
								h("Button", {
									props: Object.assign({}, this.buttonProps, {
										icon: "ios-add"
									}),
									style: {
										marginRight: "8px"
									},
									on: {
										click: () => {
											this.clickTreeSave(root, node, data);
										}
									}
								}),
								h("Button", {
									props: Object.assign({}, this.buttonProps, {
										icon: "ios-remove"
									}),
									style: {
										marginRight: "8px"
									},
									on: {
										click: () => {
											this.clickTreeDelete(root, node, data);
										}
									}
								}),
								h("Button", {
									props: Object.assign({}, this.buttonProps, {
										icon: "ios-create-outline"
									}),
									style: {
										marginRight: "8px"
									},
									on: {
										click: () => {
											this.clickTreeUpdate(root, node, data);
										}
									}
								}),
							]
						)
					]
				);
			},
			clickTreeSave(root, node, data) {
				this.currentRow = {};
				if (data.num && data.num.trim().length > 0) {
					this.currentRow.parentNum = data.num;
					this.currentRow.parentName = data.name;
				}
				this.showType = 'save';
				this.showTitle = '新增';
				this.showDialog = true;
				if (!data.expand && data.children) {
					this.$set(data, "expand", true);
				}
			},
			clickTreeUpdate(root, node, data) {
				this.currentRow = Object.assign({}, data, {
					password: ''
				});
				this.showType = 'update';
				this.showTitle = '编辑';
				this.showDialog = true;
			},
			clickTreeDelete(root, node, data) {
				let that = this;
				if (data.children && data.children.length > 0) {
					that.$Notice.info({
						title: "提示",
						desc: "存在下级，不能删除！"
					});
					this.$set(data, "expand", true);
					return;
				}
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/staff/delete",
							type: "post",
							data: {
								num: data.num
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.getDataTree();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			submitTreeUpdate() {
				let that = this;
				that.submitLoading = true;
				delete that.currentRow.createTime;
				$.ajax({
					url: "/api/meter/admin/staff/" + that.showType,
					type: "post",
					data: that.currentRow,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "提交成功"
						});
						that.showDialog = false;
						that.getDataTree();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			getDataList() {
				var that = this;
				that.loading = true;
				$.ajax({
					url: "/api/meter/admin/staff/getPage?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			getDataTree() {
				var that = this;
				that.loading = true;
				$.ajax({
					url: "/api/meter/admin/staff/getTree",
					type: "post",
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						let arr = [];
						arr.push({
							name: '层级结构',
							expand: true,
							children: result.data,
							render: that.renderRootContent
						});
						that.data2 = arr;
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			}
		}
	};
</script>

<style>
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}
</style>
